import request from '@/utils/request'
import constant from '@/constant'

function list(formData){
  return request.post(constant.serverUrl + "/open/linksApi/list", formData);
}

export default {
  list
}